import InfoBoxLayoutType from 'common/questionnaires/InfoBoxLayoutType';
import { QuestionTextField, QuestionButtonsField, QuestionYesNoField } from 'components/Questionnaires/fields';
import QuestionInformationBox from 'components/Questionnaires/QuestionInformationBox';
import FormResult from 'components/Questionnaires/Results/FormResult';
import CombinedFormResult from 'components/Questionnaires/Results/CombinedFormResult';
import RemainingW8Result from 'components/Questionnaires/Results/RemainingW8Result';
import NoFormRequiredResult from 'components/Questionnaires/Results/NoFormRequiredResult';

export const mapCustomerTypeToAnswer = (customerType) => {
  if (customerType === 'Individual') {
    return 'Yes';
  }
  if (customerType === 'Entity') {
    return 'No';
  }
  return undefined;
};

const preQual = (rcEnabled, customerType) => {
  const showRcFormQuestions = rcEnabled;
  return {
    blocks: [
      {
        id: 'individual',
        component: undefined, // Component for Block
        visible: true,
        expandCollapse: false,
        questions: [
          {
            id: 'answer',
            component: QuestionButtonsField,
            componentProps: {
              buttons: [
                { value: 'Yes', text: 'questionnaire.buttons.Individual' },
                { value: 'No', text: 'questionnaire.buttons.Organisation' }
              ]
            },
            label: 'preQualifyingQuestionnaire.INDIVIDUAL.questionText',
            visible: true,
            default: mapCustomerTypeToAnswer(customerType),
            info: {
              component: QuestionInformationBox,
              componentProps: {
                reference: 'preQualifyingQuestionnaire.INDIVIDUAL.informationText',
              }
            }
          },
        ],
      },
      {
        id: 'usIncome',
        component: undefined, // Component for Block
        visible: (qAnswers, pAnswers) => qAnswers?.individual?.answer !== undefined && qAnswers?.individual?.answer !== '',
        expandCollapse: false,
        questions: [
          {
            id: 'answer',
            component: QuestionYesNoField,
            label: 'preQualifyingQuestionnaire.USINCOME-INDIVIDUAL.questionText',
            visible: (bAnswers, qAnswers, pAnswers) => qAnswers?.individual?.answer === 'Yes',
            info: {
              component: QuestionInformationBox,
              componentProps: {
                reference: 'preQualifyingQuestionnaire.USINCOME-INDIVIDUAL.informationText',
              }
            }
          },
          {
            id: 'answer',
            component: QuestionYesNoField,
            label: 'preQualifyingQuestionnaire.USINCOME-ENTITY.questionText',
            visible: (bAnswers, qAnswers, pAnswers) => qAnswers?.individual?.answer === 'No',
            info: {
              component: QuestionInformationBox,
              componentProps: {
                reference: 'preQualifyingQuestionnaire.USINCOME-ENTITY.informationText',
              }
            }
          },
          {
            id: 'dbaDre',
            label: 'preQualifyingQuestionnaire.DBA-DRE.questionText',
            component: QuestionYesNoField,
            className: 'embedded col-12',
            visible: (bAnswers, qAnswers) => qAnswers?.individual?.answer === 'No' && bAnswers?.answer === 'Yes',
            info: {
              component: QuestionInformationBox,
              componentProps: {
                reference: 'preQualifyingQuestionnaire.DBA-DRE.informationText',
              }
            }
          },
          {
            id: 'soleOwner',
            label: 'preQualifyingQuestionnaire.LEGAL-SOLE-OWNER-INDIVIDUAL.questionText',
            component: QuestionYesNoField,
            className: 'embedded col-12',
            visible: (bAnswers, qAnswers) => qAnswers?.individual?.answer === 'No' && bAnswers?.answer === 'Yes' && bAnswers?.dbaDre === 'Yes',
            info: {
              component: QuestionInformationBox,
              componentProps: {
                reference: 'preQualifyingQuestionnaire.LEGAL-SOLE-OWNER-INDIVIDUAL.informationText',
              }
            }
          },
          {
            id: 'soleOwnerIndividualFirstName',
            label: 'preQualifyingQuestionnaire.LEGAL-SOLE-OWNER-INDIVIDUAL-NAME.first.label',
            component: QuestionTextField,
            className: 'embedded col-4',
            visible: (bAnswers, qAnswers) => qAnswers?.individual?.answer === 'No' && bAnswers?.answer === 'Yes' && bAnswers?.dbaDre === 'Yes' && bAnswers.soleOwner === 'Yes',
          },
          {
            id: 'soleOwnerIndividualMiddleName',
            label: 'preQualifyingQuestionnaire.LEGAL-SOLE-OWNER-INDIVIDUAL-NAME.middle.label',
            component: QuestionTextField,
            className: 'embedded col-4',
            visible: (bAnswers, qAnswers) => qAnswers?.individual?.answer === 'No' && bAnswers?.answer === 'Yes' && bAnswers?.dbaDre === 'Yes' && bAnswers.soleOwner === 'Yes',
          },
          {
            id: 'soleOwnerIndividualLastName',
            label: 'preQualifyingQuestionnaire.LEGAL-SOLE-OWNER-INDIVIDUAL-NAME.last.label',
            component: QuestionTextField,
            className: 'embedded col-4',
            visible: (bAnswers, qAnswers) => qAnswers?.individual?.answer === 'No' && bAnswers?.answer === 'Yes' && bAnswers?.dbaDre === 'Yes' && bAnswers.soleOwner === 'Yes',
          },
          {
            id: 'soleOwnerEntity',
            label: 'preQualifyingQuestionnaire.LEGAL-SOLE-OWNER-ENTITY-NAME.questionText',
            placeholder: 'preQualifyingQuestionnaire.LEGAL-SOLE-OWNER-ENTITY-NAME.placeholder',
            component: QuestionTextField,
            className: 'embedded col-12',
            visible: (bAnswers, qAnswers) => qAnswers?.individual?.answer === 'No' && bAnswers?.answer === 'Yes' && bAnswers?.dbaDre === 'Yes' && bAnswers.soleOwner === 'No',
            info: {
              component: QuestionInformationBox,
              componentProps: {
                reference: 'preQualifyingQuestionnaire.LEGAL-SOLE-OWNER-ENTITY-NAME.informationText',
              }
            }
          },
        ],
      },
      {
        id: 'controllingPerson',
        component: undefined, // Component for Block
        visible: (bAnswers, qAnswers) => !showRcFormQuestions && qAnswers?.individual?.answer === 'Yes' && qAnswers?.usIncome?.answer === 'No' && !showRcFormQuestions,
        expandCollapse: false,
        questions: [
          {
            id: 'answer',
            component: QuestionYesNoField,
            label: 'preQualifyingQuestionnaire.CP.questionText',
            visible: true,
            info: {
              component: QuestionInformationBox,
              componentProps: {
                reference: 'preQualifyingQuestionnaire.CP.informationText',
              }
            }
          },
        ]
      },
      {
        id: 'crsParticipatingEntity',
        component: undefined, // Component for Block
        visible: (bAnswers, qAnswers) => qAnswers?.individual?.answer === 'No' && qAnswers?.usIncome?.answer === 'No' && !showRcFormQuestions,
        expandCollapse: false,
        questions: [
          {
            id: 'answer',
            component: QuestionYesNoField,
            label: 'preQualifyingQuestionnaire.CRS-PARTICIPATING-ENTITY.questionText',
            visible: true,
            info: {
              component: QuestionInformationBox,
              componentProps: {
                reference: 'preQualifyingQuestionnaire.CRS-PARTICIPATING-ENTITY.informationText',
              }
            }
          },
        ]
      },
      {
        id: 'usCitizen',
        component: undefined, // Component for Block
        visible: (bAnswers, qAnswers) => (qAnswers?.individual?.answer === 'Yes' && qAnswers?.usIncome?.answer === 'Yes')
        || (qAnswers?.usIncome?.soleOwner === 'Yes' && qAnswers?.usIncome?.soleOwnerIndividualFirstName?.length > 0 && qAnswers?.usIncome?.soleOwnerIndividualLastName?.length > 0),
        expandCollapse: false,
        questions: [
          {
            id: 'answer',
            component: QuestionYesNoField,
            label: 'preQualifyingQuestionnaire.US-CITIZEN.questionText',
            visible: true,
            info: {
              component: QuestionInformationBox,
              componentProps: {
                reference: 'preQualifyingQuestionnaire.US-CITIZEN.informationText',
              }
            }
          },
        ]
      },
      {
        id: 'usIncorporated',
        component: undefined, // Component for Block
        visible: (bAnswers, qAnswers) => (qAnswers?.individual?.answer === 'No' && qAnswers?.usIncome?.answer === 'Yes' && qAnswers?.usIncome?.dbaDre === 'No')
                                      || (qAnswers?.individual?.answer === 'No' && qAnswers?.usIncome?.answer === 'Yes' && qAnswers?.usIncome?.soleOwner === 'No'
        && qAnswers?.usIncome?.dbaDre === 'Yes' && qAnswers?.usIncome?.soleOwnerEntity?.length > 0),
        expandCollapse: false,
        questions: [
          {
            id: 'answer',
            component: QuestionYesNoField,
            label: 'preQualifyingQuestionnaire.US-INCORPORATED.questionText',
            visible: true,
            info: {
              component: QuestionInformationBox,
              componentProps: {
                complexReferences: {
                  type: InfoBoxLayoutType.ParagraphFollowedBySingleList,
                  paragraph: 'preQualifyingQuestionnaire.US-INCORPORATED.informationText.p1',
                  listReferences: ['preQualifyingQuestionnaire.US-INCORPORATED.informationText.li1', 'preQualifyingQuestionnaire.US-INCORPORATED.informationText.li2']
                }
              }
            }
          },
        ]
      },
      {
        id: 'effectiveConnectedIncome',
        component: undefined, // Component for Block
        visible: (bAnswers, qAnswers) => qAnswers?.individual?.answer === 'Yes' && qAnswers?.usCitizen?.answer === 'No',
        expandCollapse: false,
        questions: [
          {
            id: 'answer',
            component: QuestionYesNoField,
            label: 'preQualifyingQuestionnaire.EFFECTIVE-CONNECTED-INCOME.questionText',
            visible: true,
            info: {
              component: QuestionInformationBox,
              componentProps: {
                reference: 'preQualifyingQuestionnaire.EFFECTIVE-CONNECTED-INCOME.informationText',
              }
            }
          },
        ]
      },
      {
        id: 'effectiveConnectedIncome',
        component: undefined, // Component for Block
        visible: (bAnswers, qAnswers) => qAnswers?.individual?.answer === 'No' && qAnswers?.usCitizen?.answer === 'No',
        expandCollapse: false,
        questions: [
          {
            id: 'answer',
            component: QuestionYesNoField,
            label: 'preQualifyingQuestionnaire.EFFECTIVE-CONNECTED-INCOME-ENTITY.questionText',
            visible: true,
            info: {
              component: QuestionInformationBox,
              componentProps: {
                reference: 'preQualifyingQuestionnaire.EFFECTIVE-CONNECTED-INCOME.informationText',
              }
            }
          },
        ]
      },
      {
        id: 'canadianAccount',
        component: undefined, // Component for Block
        visible: (bAnswers, qAnswers) => ((qAnswers?.individual?.answer === 'Yes' && qAnswers?.effectiveConnectedIncome?.answer === 'No') || qAnswers?.usIncome?.answer === 'No') && showRcFormQuestions,
        expandCollapse: false,
        questions: [
          {
            id: 'answer',
            component: QuestionYesNoField,
            label: 'preQualifyingQuestionnaire.CANADIAN-ACCOUNT-INDIVIDUAL.questionText',
            visible: true,
            info: {
              component: QuestionInformationBox,
              componentProps: {
                reference: 'preQualifyingQuestionnaire.CANADIAN-ACCOUNT-INDIVIDUAL.informationText',
              }
            }
          },
        ]
      },
      {
        id: 'crsPartipatingAccount',
        component: undefined, // Component for Block
        visible: (bAnswers, qAnswers) => qAnswers?.individual?.answer === 'Yes' && qAnswers?.effectiveConnectedIncome?.answer === 'No' && !showRcFormQuestions,
        expandCollapse: false,
        questions: [
          {
            id: 'answer',
            component: QuestionYesNoField,
            label: 'preQualifyingQuestionnaire.CRS-PARTICIPATING-ACCOUNT.questionText',
            visible: true,
            info: {
              component: QuestionInformationBox,
              componentProps: {
                reference: 'preQualifyingQuestionnaire.CRS-PARTICIPATING-ACCOUNT.informationText',
              }
            }
          },
        ]
      },
      {
        id: 'nonUsResidencyIncome',
        component: undefined, // Component for Block
        visible: (bAnswers, qAnswers) => qAnswers?.individual?.answer === 'No' && qAnswers?.effectiveConnectedIncome?.answer === 'No' && !showRcFormQuestions,
        expandCollapse: false,
        questions: [
          {
            id: 'answer',
            component: QuestionYesNoField,
            label: 'preQualifyingQuestionnaire.NON-US-RESIDENCY.questionText',
            visible: true,
            info: {
              component: QuestionInformationBox,
              componentProps: {
                reference: 'preQualifyingQuestionnaire.NON-US-RESIDENCY.informationText',
              }
            }
          },
        ]
      },
      {
        id: 'canadianResidencyAccount',
        component: undefined, // Component for Block
        visible: (bAnswers, qAnswers) => qAnswers?.individual?.answer === 'No' && qAnswers?.effectiveConnectedIncome?.answer === 'No' && showRcFormQuestions,
        expandCollapse: false,
        questions: [
          {
            id: 'answer',
            component: QuestionYesNoField,
            label: 'preQualifyingQuestionnaire.CERTIFY-RESIDENCY-ACCOUNT-IN-CANADA.questionText',
            visible: true,
            info: {
              component: QuestionInformationBox,
              componentProps: {
                reference: 'preQualifyingQuestionnaire.CERTIFY-RESIDENCY-ACCOUNT-IN-CANADA.informationText',
              }
            }
          },
        ]
      },
    ],
    results: [
      {
        id: 'crsE',
        condition: qAnswers => qAnswers?.individual?.answer === 'No' && qAnswers?.usIncome?.answer === 'No'
        && (qAnswers?.crsParticipatingEntity?.answer === 'No' || qAnswers?.crsParticipatingEntity?.answer === 'Yes'),
        title: 'CRS-E',
        formType: 'crse',
        component: FormResult
      },
      {
        id: 'crsCp',
        condition: qAnswers => qAnswers?.individual?.answer === 'Yes' && qAnswers?.usIncome?.answer === 'No' && qAnswers?.controllingPerson?.answer === 'Yes' && !showRcFormQuestions,
        title: 'CRS-CP',
        formType: 'crscp',
        component: FormResult
      },
      {
        id: 'crsI',
        condition: qAnswers => qAnswers?.individual?.answer === 'Yes' && qAnswers?.usIncome?.answer === 'No' && qAnswers?.controllingPerson?.answer === 'No' && !showRcFormQuestions,
        title: 'CRS-I',
        formType: 'crsi_2024',
        component: FormResult
      },
      {
        id: 'combinedIndividual',
        condition: qAnswers => qAnswers?.crsPartipatingAccount?.answer === 'Yes' && (qAnswers?.usIncome?.dbaDre !== 'Yes' || qAnswers?.usIncome?.soleOwnerEntity?.length > 0),
        component: CombinedFormResult,
        componentProps: {
          precedence: [
            { title: 'FATCA/CRS-I', formType: 'fatca_crsi_2023' },
            { title: 'CRS-I & W-8BEN', formGroup: 'crsiw8ben' }
          ],
        },
      },
      /* {
      id: 'fatcaCrsE',
      condition: qAnswers => qAnswers?.individual?.answer === 'No' && qAnswers?.usIncome?.answer === 'No' && qAnswers?.crsParticipatingEntity?.answer === 'Yes',
      title: 'FATCA/CRS-E',
      formType: 'fatcacrse',
      component: FormResult
    }, */
      {
        id: 'w8Ben',
        condition: qAnswers => qAnswers?.nonUsResidencyIncome?.answer === 'Yes'
                  || qAnswers?.nonUsResidencyIncome?.answer === 'No'
                  || qAnswers?.crsPartipatingAccount?.answer === 'No'
                  || qAnswers?.canadianResidencyAccount?.answer === 'No',
        title: 'W-8BEN',
        formType: 'w8ben_2021',
        component: FormResult
      },
      {
        id: 'w8Eci',
        condition: qAnswers => qAnswers?.effectiveConnectedIncome?.answer === 'Yes',
        title: 'W-8ECI',
        formType: 'w8eci_2021',
        component: FormResult
      },
      {
        id: 'w9',
        condition: qAnswers => qAnswers?.usIncorporated?.answer === 'Yes' || qAnswers?.usCitizen?.answer === 'Yes',
        title: 'W-9',
        formType: 'w9_2024',
        component: FormResult
      },
      {
        id: 'remainingW8',
        condition: qAnswers => qAnswers?.usIncorporated?.answer === 'No',
        title: 'preQualifyingQuestionnaire.REMAINING-W8.questionText',
        component: RemainingW8Result,
        componentProps: {
          formTypes: [
            { title: 'W-8BEN-E', formType: 'w8bene_2021' },
            { title: 'W-8IMY', formType: 'w8imy_2021' },
            { title: 'W-8ECI', formType: 'w8eci_2021' },
            { title: 'W-8EXP', formType: 'w8exp_2023' },
          ]
        },
        info: {
          component: QuestionInformationBox,
          componentProps: {
            reference: 'preQualifyingQuestionnaire.REMAINING-W8.informationText',
          }
        }
      },
      {
        id: 'rc518',
        condition: qAnswers => (qAnswers?.canadianAccount?.answer === 'Yes' && qAnswers?.individual?.answer === 'Yes') || qAnswers?.canadianResidencyAccount?.answer === 'Yes',
        title: 'RC518',
        formType: 'rc518_2025',
        component: FormResult
      },
      {
        id: 'rc519',
        condition: qAnswers => qAnswers?.canadianAccount?.answer === 'Yes' && qAnswers?.individual?.answer === 'No',
        title: 'RC519',
        formType: 'rc519_2025',
        component: FormResult
      },
      {
        id: 'noFormRequired',
        condition: qAnswers => qAnswers?.canadianAccount?.answer === 'No',
        component: NoFormRequiredResult
      }
    ]
  };
};

export default preQual;
